import { useEffect, useState } from 'react'
import { healthApi, type BackendInfo } from '../../api/client'
import { FRONTEND_BUILD, FRONTEND_COMMIT } from '../../version'

export default function Footer() {
  const [backend, setBackend] = useState<BackendInfo | null>(null)

  useEffect(() => {
    let cancelled = false
    void healthApi.info().then((info) => {
      if (!cancelled) setBackend(info)
    })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="text-center text-gray-600 text-sm">
          <p>MPCFillToPDF Web</p>
          <p className="mt-2">
            <a
              href="https://github.com/Diphendara/MPCFillToPDFWeb"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              GitHub
            </a>
          </p>
          <p className="mt-2 text-xs text-gray-400 font-mono">
            Web v{FRONTEND_BUILD} ({FRONTEND_COMMIT})
            {' · '}
            {backend
              ? `API v${backend.build} (${backend.commit})`
              : 'API —'}
          </p>
        </div>
      </div>
    </footer>
  )
}
